// A wrapper for <Route> that redirects to the login

import { Redirect, Route, RouteProps } from 'react-router'
import { useAuth } from '../../lib/hooks'

// screen if you're not yet authenticated.
const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const auth = useAuth()

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (auth.user?.profil === 'GESTIONNAIRE') {
          return children
        } else {
          localStorage.removeItem('jwt')
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          )
        }
      }}
    />
  )
}

export default PrivateRoute
